<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="productDetailAllocationInfo.orders"
        border
        style="width: 100%"
        size="small"
      >
        <el-table-column prop="orderId" label="调拨单号" align="center" />
        <el-table-column prop="prodName" label="商品名称" align="center" />
        <el-table-column prop="specName" label="商品规格" align="center" />
        <el-table-column prop="shopName" label="源店铺" align="center" />
        <el-table-column prop="srcShName" label="源仓库" align="center" />
        <el-table-column prop="targetShopName" label="目标店铺" align="center" />
        <el-table-column prop="targetShName" label="目标仓库" align="center" />
        <el-table-column prop="productCount" label="商品数量" align="center" />
        <el-table-column prop="staffName" label="调拨人" align="center" />
        <el-table-column prop="stateName" label="状态" align="center" />
        <el-table-column prop="createTime" label="调拨时间" align="center" />
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next"
            :total="pagination.total"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryAllocationOrder } from '@/api/goods/productDetailApi'

export default {
  name: 'ProductDetailAllocation',
  data() {
    return {
      productDetailAllocationInfo: {
        orders: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailAllocationInfo.productId = params.productId
      this.loadProductDetailAllocationData()
    },
    async loadProductDetailAllocationData() {
      const res = await queryAllocationOrder({
          productId: this.productDetailAllocationInfo.productId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          shopId: getShopId()
      })

      this.productDetailAllocationInfo.orders = res.data
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailAllocationData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>